import "./QuantityInventory.scss";

export default function QuantityInventory() {
  return (
    <section className="sales-layout__page quantity-inventory">
      <h1>Mengen Inventur</h1>
      <p>Hier wird zukünftig die Mengeninventur durchgeführt.</p>
    </section>
  );
}
